import { useFormContext } from 'react-hook-form'

import { FormField, FormItem } from '@fortem-monorepo/react-ui'
import { Tabs, TabsList, TabsTrigger } from '@fortem-monorepo/react-ui'

import { SchemaType } from '@/components/forms/RunRiskCalibrationForm/RunRiskCalibrationForm.schema'
import { INPUT_TYPES, InputType } from '@/components/forms/RunRiskCalibrationForm/enums'
import { AllJobsFields } from '@/components/forms/RunRiskCalibrationForm/fields/AllJobsFields'
import { CalibrationFields } from '@/components/forms/RunRiskCalibrationForm/fields/CalibrationFields'
import { CustomRiskFields } from '@/components/forms/RunRiskCalibrationForm/fields/CustomRiskFields'
import { CustomStrategiesFields } from '@/components/forms/RunRiskCalibrationForm/fields/CustomStrategiesFields'
import { DefaultRiskFields } from '@/components/forms/RunRiskCalibrationForm/fields/DefaultRiskFields'
import { DerivedMetricsFields } from '@/components/forms/RunRiskCalibrationForm/fields/DerivedMetricsFields'
import { VolDivAdjustmentsFields } from '@/components/forms/RunRiskCalibrationForm/fields/VolDivAdjustmentsFields'

const formFieldMap: Record<InputType, React.ComponentType> = {
  [INPUT_TYPES.ALL_JOBS]: AllJobsFields,
  [INPUT_TYPES.CUSTOM_STRATEGIES]: CustomStrategiesFields,
  [INPUT_TYPES.VOLDIV_ADJUSTMENTS]: VolDivAdjustmentsFields,
  [INPUT_TYPES.CALIBRATION]: CalibrationFields,
  [INPUT_TYPES.DEFAULT_RISK]: DefaultRiskFields,
  [INPUT_TYPES.CUSTOM_RISK]: CustomRiskFields,
  [INPUT_TYPES.DERIVED_METRICS]: DerivedMetricsFields,
}

export interface RunRiskCalibrationFormFieldsProps {}

export const RunRiskCalibrationFormFields: React.FC<RunRiskCalibrationFormFieldsProps> = ({}) => {
  const { setValue, control, watch } = useFormContext<SchemaType>()

  const input_type = watch('input_type')
  const FormFields = formFieldMap[input_type]

  return (
    <div className={'flex flex-col gap-6'}>
      <div className="flex-1">
        <FormField
          name="input_type"
          control={control}
          render={({ field: { value } }) => {
            return (
              <Tabs
                value={value}
                onValueChange={(val) =>
                  setValue('input_type', val as InputType, {
                    shouldValidate: true,
                  })
                }
              >
                <FormItem>
                  <TabsList>
                    <TabsTrigger value={'all_jobs'}>All Jobs</TabsTrigger>
                    <TabsTrigger value={'derived_metrics'}>Derived Metrics</TabsTrigger>
                    <TabsTrigger value={'custom_strategies'}>Custom Strategies</TabsTrigger>
                    <TabsTrigger value={'vol_div_adjustments'}>Vol-Div Adjustments</TabsTrigger>
                    <TabsTrigger value={'calibration'}>Calibration</TabsTrigger>
                    <TabsTrigger value={'default_risk'}>Default Risk</TabsTrigger>
                    <TabsTrigger value={'custom_risk'}>Custom Risk</TabsTrigger>
                  </TabsList>
                </FormItem>
              </Tabs>
            )
          }}
        />
      </div>
      <div className={'@container'}>{FormFields && <FormFields />}</div>
    </div>
  )
}
